module.exports = __webpack_public_path__ + "img/news14_4.709da92c.jpg";